import config from "../../settings/config";
import { getAuthToken } from "../../services/authStorage";

export const baseUrl = config.env[config.env.mode].url;
export const baseNode = config.env[config.env.mode].node;

export const headersDefault = () => {
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAuthToken()}`,
  };
};

export * from "./userActions";
export * from "./groupsActions";
export * from "./courseActions";
export * from "./dietPlanActions";
export * from "./homeGroupActions";
export * from "./pushSettingsActions";
export * from "./subscriptionsActions";
export * from "./NotificationsActions";
export * from "./multimediaGroupsActions";
export * from "./clearDataActions";
export * from "./pushMuteActions";
export * from "./protocolActions";
export * from "./socialActions";
export * from "./streamChatActions";
export * from "./coinsActions";
export * from "./preRegisterActions";
export * from "./profileSettingsActions";
export * from "./accountDeletionActions";
export * from "./profilePushNotificationsActions";
export * from "./mioPercorsoActions";
export * from "./primaDopoActions";
export * from "./notificationRecipientsActions";
export * from "./streamingActions";
export * from "./undesirableFoodsActions";
export * from "./challengesActions";
export * from "./videosActions";
export * from "./permissionsActions";
export * from "./communitySortOrderActions";
export * from "./storiesActions";
